module.exports = __webpack_public_path__ + "img/colored-rounded.9ac83877.svg";